import { useEffect, useState } from 'react';

import { extractFromSlug } from 'helpers/utils';
import { LandingTab } from 'components/Landing/types';

import type CatalogStore from 'stores/Catalog';
import type { RouterStore } from 'mobx-router5';

type UsePremiumLandingRedirectOptions = {
  sessionSlug: string | undefined;
  catalogStore: CatalogStore;
  routerStore: RouterStore;
};

/**
 * When catalog is loaded, checks if this premium session has a linked course.
 * If so, redirects to Course Landing for the richer experience.
 */
export default function usePremiumLandingRedirect({
  sessionSlug,
  catalogStore,
  routerStore,
}: UsePremiumLandingRedirectOptions) {
  const [redirectToCourseLanding, setRedirectToCourseLanding] = useState(false);

  useEffect(() => {
    if (
      !sessionSlug ||
      !catalogStore.hasCatalogLoaded ||
      redirectToCourseLanding
    ) {
      return;
    }

    const { code, version } = extractFromSlug(sessionSlug);
    if (!version) return;

    const catalogEntry = catalogStore.getCatalogEntryForCourse(
      code.toLowerCase(),
      version.toLowerCase(),
    );

    if (catalogEntry) {
      setRedirectToCourseLanding(true);
      routerStore.navigate(
        'courses:overview',
        { course: sessionSlug, tab: LandingTab.PremiumSessions },
        // @ts-ignore - router5 options
        { replace: true },
      );
    }
  }, [
    catalogStore,
    catalogStore.hasCatalogLoaded,
    redirectToCourseLanding,
    routerStore,
    sessionSlug,
  ]);

  return redirectToCourseLanding;
}
